import '../teacher.css'
import { Outlet } from 'react-router-dom'
import { ControlNotificaciones } from './ControlNotificaciones'
import { HelpButton } from './HelpButton'
import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { isSuccess } from 'helpers/isSuccess'
import { formatDate } from 'utils'
import { ServerDateContext } from 'contexts/ServerDateContext'
import Loading from 'pages/Loading'

export default function LayoutDocente() {
    const initialServerDate = useRef(null)
    const serverDate = useRef(null)
    const interval = useRef(null)
    const elapsedSeconds = useRef(0)
    const [timeString, setTimeString] = useState('')
    const [dateString, setDateString] = useState('')
    const [dateTimeString, setDateTimeString] = useState('')
    const [localeDateTimeString, setLocaleDateTimeString] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const loadStates = () => {
            serverDate.current = new Date(initialServerDate.current)
            serverDate.current.setSeconds(serverDate.current.getSeconds() + elapsedSeconds.current)
            const timeString = formatDate(serverDate.current, 'H:i:s')
            const dateString = formatDate(serverDate.current)
            setTimeString(timeString)
            setDateString(dateString)
            setDateTimeString(`${dateString} ${timeString}`)
            setLocaleDateTimeString(`${formatDate(serverDate.current, 'j M Y').toLowerCase()}, ${timeString} GMT-4`)
            elapsedSeconds.current++
        }
        const load = async () => {
            const {
                status,
                data: { data },
            } = await axios.get(process.env.REACT_APP_API_URL + 'app/status')
            if (isSuccess(status)) {
                initialServerDate.current = data.server_time
                loadStates()
                interval.current = setInterval(() => loadStates(), 1000)
            }
            setLoading(false)
        }
        load()
        return () => {
            clearInterval(interval.current)
        }
    }, [])

    if (loading) return <Loading />
    if (!timeString) {
        return (
            <div className='flex-1 d-flex justify-content-center align-items-center'>
                <div className='d-flex align-items-center gap-2'>
                    <div className='font-medium' style={{ fontSize: '2rem' }}>
                        500
                    </div>
                    <div className='border-end' style={{ height: '2.5rem !important' }} />
                    <div>Error Interno del Servidor.</div>
                </div>
            </div>
        )
    }

    return (
        <ServerDateContext.Provider
            value={{ serverDate, timeString, dateString, dateTimeString, localeDateTimeString }}
        >
            <Outlet />
            <ControlNotificaciones />
            <HelpButton />
        </ServerDateContext.Provider>
    )
}
